import { logout } from "@/api/auth";
import { useAuth } from "@/hooks/useAuth";
import { Code, Gear, House, SignOut } from "@phosphor-icons/react";
import { Link, Outlet, useNavigate } from "react-router-dom";
import { NotificationBell } from "../NotificationBell";

export function DevLayout() {
  const auth = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    await auth.refresh();
    navigate("/");
  };

  return (
    <div className="flex min-h-screen flex-col bg-(--color-bg) text-text-primary">
      {/* Dev header */}
      <header className="sticky top-0 z-50 flex h-12 items-center justify-between border-b border-border bg-bg-card/95 backdrop-blur-sm px-6">
        <div className="flex items-center gap-4">
          <Link
            to="/"
            className="flex items-center gap-1.5 text-text-muted hover:text-text-primary transition-colors"
          >
            <House size={16} />
          </Link>
          <Link
            to="/dev-portal"
            className="flex items-center gap-2 text-sm font-semibold text-primary hover:opacity-80 transition-opacity"
          >
            <Code size={18} weight="bold" />
            <span>Developer Portal</span>
          </Link>
        </div>
        <div className="flex items-center gap-3">
          <NotificationBell />
          <Link
            to="/settings"
            className="text-text-muted hover:text-text-primary transition-colors"
          >
            <Gear size={16} />
          </Link>
          <button
            onClick={handleLogout}
            className="flex items-center gap-1.5 text-xs text-text-muted hover:text-text-primary transition-colors"
          >
            <SignOut size={14} />
            Sign out
          </button>
        </div>
      </header>

      {/* Page content */}
      <main id="main" className="flex-1">
        <Outlet />
      </main>
    </div>
  );
}
